import './App.css';
import MarkdowPreviewer from './MarkdownPreviewer';

function App() {
  return (
    <div className="App">
    <MarkdowPreviewer />      
    </div>
  );
}

export default App;
